import { render, staticRenderFns } from "./ShowAside.vue?vue&type=template&id=4b77be21&scoped=true&"
import script from "./ShowAside.vue?vue&type=script&lang=js&"
export * from "./ShowAside.vue?vue&type=script&lang=js&"
import style0 from "./ShowAside.vue?vue&type=style&index=0&id=4b77be21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b77be21",
  null
  
)

export default component.exports